import { render, staticRenderFns } from "./Programa-cobradores.vue?vue&type=template&id=28c2a720"
import script from "./Programa-cobradores.vue?vue&type=script&lang=js"
export * from "./Programa-cobradores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports